<template>
  <div class="toogle" style="font-size:1.4rem" @click="onChange">
    <!-- <i  class="fa fa-fw fa-toggle-on"></i> -->
    <b-icon-toggle-on class="fa-toggle-on" v-show="value"></b-icon-toggle-on>
    <b-icon-toggle-off v-show="!value"></b-icon-toggle-off>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      // required: true,
      default: false,
    },
  },
  data() {
    return {
      
    };
  },
  computed: {},
  mounted() {},
  methods: {
    onChange(){
      this.$emit('change');
    },
  },
};
</script>
<style scoped>
.toogle{
    cursor:pointer;
}
.fa-toggle-on{
    color: #c11314;
}
.fa-fw{
    font-size: 20px;
}
</style>